import { RouteRecordRaw } from 'vue-router';

import OnboardingPersonalLayout from '@/modules/onboarding-personal-profile/components/onboarding-personal-layout.vue';
import PersonalProfileKyc from '@/modules/onboarding-personal-profile/pages/personal-profile-kyc/personal-profile-kyc.vue';
import { RoutePermission } from '@/router/route-permission';
import { usePersonalOnboardingStore } from '@/stores';

const PersonalProfileWallets = () => import('@/modules/onboarding-user-profile/pages/user-profile-wallets/user-profile-wallets.vue');

const PersonalProfileTransactions = () => import('@/modules/transactions-old/pages/transactions.vue');
const PersonalProfileContracts = () => import('@/modules/user-profile/pages/user-profile-contracts/user-profile-contracts.vue');
const PersonalProfileLoginAndSecurity = () => import('@/modules/onboarding-user-profile/pages/user-login-and-security/user-login-and-security.vue');
const PersonalProfileSubscriptions = () => import('@/modules/user-profile/pages/user-subscriptions/index.vue');

const ONBOARDING_PERSONAL_PROFILE_META = {
  groupName: 'onboarding-personal-profile',
  layout: {
    props: {
      backName: [
        'onboarding-users',
      ],
    },
  },
};

export const ONBOARDING_PERSONAL_PROFILE_CHILDREN: RouteRecordRaw[] = [
  {
    path: 'profile',
    name: 'onboarding-personal-details',
    component: PersonalProfileKyc,
    meta: {
      translation: 'pages.user_profile.navigation.profile',
      ...ONBOARDING_PERSONAL_PROFILE_META,
    },
  },
  {
    path: 'wallets',
    name: 'onboarding-personal-wallets',
    component: PersonalProfileWallets,
    props: () => ({
      organizationId: usePersonalOnboardingStore().userDetails.value!.organizationId,
    }),
    meta: {
      translation: 'pages.user_profile.navigation.wallets',
      ...ONBOARDING_PERSONAL_PROFILE_META,
    },
  },
  {
    path: 'contracts',
    name: 'onboarding-personal-contracts',
    component: PersonalProfileContracts,
    props: () => ({
      userId: usePersonalOnboardingStore().userDetails.value!.userId,
      organizationId: usePersonalOnboardingStore().userDetails.value!.organizationId,
      role: usePersonalOnboardingStore().userDetails.value!.role,
    }),
    meta: {
      translation: 'pages.user_profile.navigation.contracts',
      ...ONBOARDING_PERSONAL_PROFILE_META,
    },
  },
  {
    path: 'transactions',
    name: 'onboarding-personal-transactions',
    component: PersonalProfileTransactions,
    props: () => ({
      defaultFilter: {
        orgIds: [usePersonalOnboardingStore().userDetails.value!.organizationId],
      },
      isTitleVisible: false,
      isFullPage: false,
    }),
    meta: {
      translation: 'pages.user_profile.navigation.transactions',
      ...ONBOARDING_PERSONAL_PROFILE_META,
    },
  },
  {
    path: 'login-and-security',
    name: 'onboarding-personal-login-and-security',
    component: PersonalProfileLoginAndSecurity,
    props: () => ({
      userId: usePersonalOnboardingStore().userDetails.value!.userId,
    }),
    meta: {
      translation: 'pages.user_profile.navigation.login_and_security',
      ...ONBOARDING_PERSONAL_PROFILE_META,
    },
  },
  {
    path: 'subscriptions',
    name: 'onboarding-personal-subscriptions',
    component: PersonalProfileSubscriptions,
    props: () => ({
      organizationId: usePersonalOnboardingStore().userDetails.value!.organizationId,
    }),
    meta: {
      translation: 'pages.contracts.navigation.subscriptions',
      ...ONBOARDING_PERSONAL_PROFILE_META,
    },
  },
];

export const ONBOARDING_PERSONAL: RouteRecordRaw = {
  path: '/dashboard/customers/personal/:id',
  name: ONBOARDING_PERSONAL_PROFILE_META.groupName,
  children: ONBOARDING_PERSONAL_PROFILE_CHILDREN,
  component: OnboardingPersonalLayout,
  redirect: (to) => ({
    name: ONBOARDING_PERSONAL_PROFILE_CHILDREN[0].name,
    params: to.params,
  }),
  meta: {
    permission: RoutePermission.ONBOARDING_USERS,
    root: false,
    ...ONBOARDING_PERSONAL_PROFILE_META,
  },
};
